import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

/** Include saved values missing from today's catalogue so opening an editor never discards them. */
const ValuePicker = ({
  value,
  onChange,
  options = [],
  multiple = false,
  creatable = false,
  disabled = false,
  label,
  loading = false,
  isValidNewOption,
  formatOptionLabel
}) => {
  const values = (
    multiple ? (Array.isArray(value) ? value : value ? [value] : []) : [value]
  ).filter(v => v !== '' && v != null);
  const expanded = [
    ...options,
    ...values
      .filter(v => !options.some(o => o.value === v))
      .map(v => ({ value: v, label: String(v) }))
  ];
  const selected = values.map(v => expanded.find(o => o.value === v));
  const Picker = creatable ? CreatableSelect : Select;
  return (
    <Picker
      aria-label={label}
      options={expanded}
      value={multiple ? selected : selected[0] || null}
      isMulti={multiple}
      isClearable
      isDisabled={disabled}
      isLoading={loading}
      isValidNewOption={isValidNewOption}
      formatOptionLabel={formatOptionLabel}
      placeholder={multiple ? 'Select or enter values…' : 'Select…'}
      onChange={choice =>
        onChange(
          multiple ? (choice || []).map(o => o.value) : choice?.value ?? ''
        )
      }
      menuPortalTarget={
        typeof document !== 'undefined' ? document.body : undefined
      }
      styles={{ menuPortal: base => ({ ...base, zIndex: 2000 }) }}
    />
  );
};

export default ValuePicker;
